// extracted by mini-css-extract-plugin
export default {"mask":"XBEfSmJR","shineMove":"A5jK_fo5"};